import React from 'react';

/**
 * "THE CIRCLE BY CASANOVA" wax-seal wordmark — updated to match the
 * official brand-book SVG artwork. Text wraps around a top arc + a
 * bottom arc with center-anchored textPath (so both halves read
 * symmetrically with the brand's 3px letter-spacing).
 *
 * Variants:
 *   forest      — dark green disc, cream text, terracotta dots
 *   parchment   — cream disc, forest text, terracotta dots
 *   brick       — terracotta disc, cream text, cream dots
 *   noir        — near-black disc, cream text, terracotta dots
 *   transparent — no disc fill, forest text (for use over imagery)
 */
const VARIANTS = {
  forest:      { fill: '#25342C', text: '#F5F0E8', accent: '#A14223' },
  parchment:   { fill: '#F5F0E8', text: '#25342C', accent: '#A14223' },
  brick:       { fill: '#A14223', text: '#F5F0E8', accent: 'rgba(245,240,232,0.75)' },
  noir:        { fill: '#1A1A18', text: '#F5F0E8', accent: '#A14223' },
  transparent: { fill: 'none',    text: '#25342C', accent: '#A14223' },
};

const CircleWordmark = ({ variant = 'forest', size = 220, className = '', testid = 'circle-wordmark' }) => {
  const v = VARIANTS[variant] || VARIANTS.forest;
  // Unique path IDs per variant so multiple instances can coexist on
  // the same page without reusing textPath references.
  const topId = `arc-top-${variant}`;
  const botId = `arc-bot-${variant}`;
  return (
    <svg
      viewBox="0 0 300 300"
      width={size}
      height={size}
      className={className}
      data-testid={testid}
      role="img"
      aria-label="The Circle by Casanova"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <path id={topId} d="M 31,135 A 120,120 0 0,1 269,135" />
        <path id={botId} d="M 269,165 A 120,120 0 0,1 31,165" />
      </defs>
      {v.fill !== 'none' && <circle cx="150" cy="150" r="150" fill={v.fill} />}
      <text
        fontFamily="'Playfair Display','Cormorant Garamond',Georgia,serif"
        fontSize="22"
        fontWeight="400"
        fill={v.text}
        letterSpacing="3"
      >
        <textPath href={`#${topId}`} startOffset="50%" textAnchor="middle">
          THE CIRCLE BY CASANOVA
        </textPath>
      </text>
      <text
        fontFamily="'Playfair Display','Cormorant Garamond',Georgia,serif"
        fontSize="22"
        fontWeight="400"
        fill={v.text}
        letterSpacing="3"
      >
        <textPath href={`#${botId}`} startOffset="50%" textAnchor="middle">
          THE CIRCLE BY CASANOVA
        </textPath>
      </text>
      <circle cx="30" cy="150" r="3" fill={v.accent} />
      <circle cx="270" cy="150" r="3" fill={v.accent} />
      <circle cx="150" cy="150" r="2.5" fill={v.accent} />
    </svg>
  );
};

export default CircleWordmark;
